import styled from 'styled-components'

import { FontPreset } from '../styles/mixins'
import { Text } from './Text'

export const H2 = styled(Text)`
  display: block;
  ${FontPreset('h2')};
`
